import React, { FC } from 'react';
import { Tooltip, Colors, AnalyticsComponent } from '@inplayer-org/inplayer-ui';
import styled, { css } from 'styled-components';
import { IoIosImage } from 'react-icons/io';
import { FcComboChart } from 'react-icons/fc';
import { useLocation } from 'react-router';

// styled components
import { StyledReactIcon } from 'pages/MerchantPages/Audience/components/AudienceDetailsBox';

const StyledIcon = styled(StyledReactIcon)<{ disabled?: boolean }>`
  vertical-align: middle;
  margin-left: 0.5rem;

  :hover {
    transform: scale(1.2);
    transition: 0.2s ease;
  }

  ${({ disabled }) =>
    disabled &&
    css`
      cursor: default;

      :hover {
        & > svg {
          cursor: default;
        }
      }
    `}
`;

interface Props {
  itemType: string;
  isAnalyticsView?: boolean;
  toggleAnalyticsView?: () => void;
}

const ItemAnalytics: FC<Props> = ({ itemType, isAnalyticsView, toggleAnalyticsView }) => {
  const onToggleAnalyticsClick = () => {
    if (toggleAnalyticsView) {
      toggleAnalyticsView();
    }
  };

  const { pathname } = useLocation();
  const isEditTemplate = pathname.includes('templates');
  const isAsset = itemType.includes('asset');
  const itemName = isAsset ? 'asset' : 'package';
  const tagName = isEditTemplate ? 'template' : itemName;

  return (
    <AnalyticsComponent>
      {({ pages, tracker, merchantId, ip }) => (
        <Tooltip
          tag="icon_analytics"
          content={isAnalyticsView ? `View ${itemName} details` : `View ${itemName} analytics`}
        >
          {isAnalyticsView ? (
            <StyledIcon
              as={IoIosImage}
              color={Colors.blue}
              onClick={() => {
                tracker.track({
                  event: 'click',
                  type: 'icon',
                  tag: 'icon_analytics',
                  pages,
                  merchantId,
                  ip,
                });
                return onToggleAnalyticsClick();
              }}
            />
          ) : (
            <StyledIcon
              as={FcComboChart}
              color={Colors.red}
              onClick={() => {
                tracker.track({
                  event: 'click',
                  type: 'icon',
                  tag: `icon_view_${tagName}_analytics`,
                  pages,
                  merchantId,
                  ip,
                });
                return onToggleAnalyticsClick();
              }}
            />
          )}
        </Tooltip>
      )}
    </AnalyticsComponent>
  );
};

export default ItemAnalytics;
